

























































































































































































import { Component, Watch } from 'nuxt-property-decorator'
import { ModalComponentBaseVue } from '@/base'
import ModalFooter from '@/components/molecules/ModalFooter/ModalFooter.vue'
import {
  alertStore,
  appStore,
  dataStore,
  donorStore,
  modalBibliographyDetailSetStore,
  modalBibliographyDetailStore,
  modalBibliographySearchStore,
  modalErrorStore,
  modalJobListStore,
  systemCodeStore,
  systemParameterStore,
  traderStore
} from '@/store'
import {
  Alert,
  AlertMessage,
  bibliographyApi,
  BibliographySearchListDetail,
  BibliographySearchResultItem,
  bibliographySetApi,
  BibliographySetDetail,
  BibliographySetDetailAutoOrder,
  BibliographySetDetailVolume,
  defaultBibliographySetDetailAutoOrder,
  defaultSystemCode,
  ErrorMessage,
  FirstMarcLabel,
  jobApi,
  marcLabelApi,
  SystemCode
} from '@/api'
import CollectionMagazineNameMarcTable from '@/components/templates/collection-magazine-name-marc/CollectionMagazineNameMarcTable.vue'
import BibliographyDetailVolumeTable, {
  BibliographyDetailVolumeTableDisplayBranchCode,
  defaultBibliographyDetailVolumeTableDisplayBranchCode,
  defaultBibliographyDetailVolumeTableItem
} from '@/components/organisms/BibliographyDetailVolumeTable/BibliographyDetailVolumeTable.vue'
import BibliographySetInfo from '@/components/organisms/BibliographySetInfo/BibliographySetInfo.vue'
import SearchResultPagination from '@/components/molecules/SearchResultPagination/SearchResultPagination.vue'
import {
  BibliographyClass,
  BibliographyDetailRealTabType,
  BibliographyDetailSetTabType,
  BibliographyFullId,
  Prefix,
  SearchType
} from '@/types'
import { BibliographyTagDataList } from '@/components/templates/bibliography-tag-data-list'
import { cloneDeep } from 'lodash'
import { SecondAfterTransitionToBibliographyDetail } from '@/store/BibliographyDetailStore'
import {
  CollectionMagazineManagementInfo,
  CollectionMagazineManagementInfoItem,
  defaultCollectionMagazineManagementInfoItem
} from '@/components/templates/collection-magazine-management-info'
import {
  NAV_LOADING_END,
  NAV_LOADING_START,
  PAGE_LOADING_END,
  PAGE_LOADING_START
} from '@/config/event'
import {
  BibliographySetDetailItem,
  defaultBibliographySetDetailItem
} from '@/pages/bibliographies/detail-set.vue'
import { BibliographyDetailVolumeTableItemRow } from '@/components/organisms/BibliographyDetailVolumeTable'
import { defaultSortColumn } from '@/components/molecules/DataTable'
import { CODE_KEY } from '@/config'
import {
  AutoOrderTable,
  defaultAutoOrderTableItem
} from '@/components/organisms/AutoOrderTable'

@Component({
  components: {
    AutoOrderTable,
    CollectionMagazineManagementInfo,
    SearchResultPagination,
    BibliographySetInfo,
    BibliographyDetailVolumeTable,
    BibliographyTagDataList,
    CollectionMagazineNameMarcTable,
    ModalFooter
  }
})
export default class ModalBibliographyDetailSet extends ModalComponentBaseVue {
  activeTab: BibliographyDetailSetTabType = BibliographyDetailSetTabType.Volume

  bibliographySetDetail: BibliographySetDetailItem = defaultBibliographySetDetailItem()

  tableBodyHeight: number = 0

  firstMarcLabels: FirstMarcLabel[] = []

  displayBranchCode: BibliographyDetailVolumeTableDisplayBranchCode = defaultBibliographyDetailVolumeTableDisplayBranchCode()

  managementInfoInputItem: CollectionMagazineManagementInfoItem = defaultCollectionMagazineManagementInfoItem()

  isFetchingBibliographySetDetail: boolean = false

  get enableManagementInfo(): boolean {
    return dataStore.enableManagementInfo
  }

  get tabType(): any {
    return BibliographyDetailSetTabType
  }

  get initialTabType(): BibliographyDetailSetTabType {
    return modalBibliographyDetailSetStore.tabType
  }

  get currentPage(): number {
    return this.currentSearchResultIndex + 1
  }

  get currentSearchResultIndex(): number {
    return this.searchResults.findIndex(
      obj =>
        obj.bibliographyId ===
        this.bibliographySetDetail.bibliography.bibliographyId
    )
  }

  get searchResultsCount(): number {
    return this.searchResults.length
  }

  get fontSize(): number {
    return appStore._fontSizeNormal
  }

  get fontSizeType(): string {
    return appStore._fontSizeType
  }

  get isOpen(): boolean {
    return modalBibliographyDetailSetStore.isOpen
  }

  get disabledSelect(): boolean {
    return modalBibliographyDetailSetStore.disabledSelect
  }

  get showPagination(): boolean {
    return (
      modalBibliographyDetailStore.showPagination &&
      this.searchResultsCount !== 0 &&
      this.isBibliographySelectProcess
    )
  }

  get isBibliographySelectProcess(): boolean {
    return modalBibliographyDetailSetStore.isBibliographySelectProcess
  }

  get bibliographySetId(): number {
    return modalBibliographyDetailSetStore.bibliographySetId
  }

  get secondAfterTransitionSource(): SecondAfterTransitionToBibliographyDetail {
    return modalBibliographyDetailStore.secondAfterTransitionSource
  }

  get filterSearchResults(): BibliographySearchResultItem[] {
    return modalBibliographySearchStore.filterItems
  }

  get searchResults(): BibliographySearchResultItem[] {
    const notExistsSearchResultsByBibliographyDetailSet = modalBibliographySearchStore.items.every(
      searchResult =>
        searchResult.prefix !== Prefix.Set &&
        searchResult.bibliographyId !==
          this.bibliographySetDetail.bibliography.bibliographyId
    )

    if (
      notExistsSearchResultsByBibliographyDetailSet &&
      this.secondAfterTransitionSource ===
        SecondAfterTransitionToBibliographyDetail.Volume
    ) {
      return []
    } else {
      return this.filterSearchResults
    }
  }

  get isHitOneSearchResults(): boolean {
    return modalBibliographySearchStore.total === 1
  }

  get isHitOneSearchResultsContent(): boolean {
    return modalBibliographySearchStore.contentItems.length === 1
  }

  get tabStyles(): object {
    if (this.fontSizeType === 'normal') {
      return {}
    }

    return {
      'font-size': this.fontSize + 'px'
    }
  }

  @Watch('isOpen')
  initialize(newVal: boolean) {
    if (newVal) {
      traderStore.fetchAll()
      donorStore.fetchAll()
      systemCodeStore.fetchAllAndMergeByCodeKeys([CODE_KEY.LIBRARY_BRANCH.KEY])
      systemParameterStore.fetchAllAndMergeByCodeKeys([
        CODE_KEY.CALL_CONCATENATION_NUMBER_INSTRUCTION.KEY
      ])

      this.fetchBibliographySetDetail(this.bibliographySetId)
      this.$nextTick(() => {
        window.addEventListener('resize', this.onResize)
        this.calculateTableHeight()
      })
      this.activeTab = this.initialTabType
      return
    }

    window.removeEventListener('resize', this.onResize)
    this.reset()
  }

  @Watch('showPagination')
  onChangeShowPagination(): void {
    this.calculateTableHeight()
  }

  // ダイアログ縦幅を固定としている為、計算方法が他と違う点に注意
  calculateTableHeight(): void {
    this.tableBodyHeight = 0
    this.$nextTick(() => {
      this.tableBodyHeight = this.calculateTableHeightBase()

      if (this.activeTab === BibliographyDetailSetTabType.MagazineName) {
        const bibliographyElements: HTMLCollection | null = document.getElementsByClassName(
          'bibliography-tag-data-list'
        ) as HTMLCollectionOf<HTMLElement>
        this.tableBodyHeight +=
          bibliographyElements[0].children[0].clientHeight -
          bibliographyElements[0].children[1].clientHeight +
          10
      }
    })
  }

  close(): void {
    modalBibliographyDetailSetStore.close()
  }

  isActiveTab(value: BibliographyDetailSetTabType): boolean {
    return this.activeTab === value
  }

  onResize(): void {
    this.calculateTableHeight()
  }

  onClickTab(value: BibliographyDetailSetTabType): void {
    if (value === this.activeTab) {
      return
    }
    this.activeTab = value
    this.$nextTick(this.calculateTableHeight)
  }

  onClickBackCondition(): void {
    modalBibliographyDetailSetStore.backCondition()
  }

  onClickBackResult(): void {
    modalBibliographyDetailStore.setSecondAfterTransitionSource(
      SecondAfterTransitionToBibliographyDetail.Not
    )
    modalBibliographyDetailSetStore.backResult()
  }

  onClickSelect(): void {
    modalBibliographyDetailSetStore.select({
      bibliographyFullId: {
        prefix: this.bibliographySetDetail.bibliography.prefix,
        id: this.bibliographySetDetail.bibliography.bibliographyId
      },
      selectedBibliographyRealId: this.bibliographySetDetail.volume.selectedRow()
        .bibliographyId
    })
  }

  onClickLink(bibliographyId: number): void {
    modalBibliographyDetailStore.setSecondAfterTransitionSource(
      SecondAfterTransitionToBibliographyDetail.Set
    )
    modalBibliographyDetailSetStore.setVolumes(
      cloneDeep(
        this.bibliographySetDetail.volume.rows.map(row => ({
          prefix: row.prefix,
          bibliographyId: row.bibliographyId,
          collectionNo: row.collectionNo,
          marcNo: row.marcNo,
          bibliographyContentId: row.bibliographyContentId,
          volume: row.volume,
          volumeNumber: row.volumeNumber,
          volumeTotal: row.volumeTotal,
          volumeDateLabel: row.volumeDateLabel,
          volumeSpecial: row.volumeSpecial,
          displayContent: row.displayContent,
          continueAndLookCode: row.continueAndLookCode,
          collectionsStatus: row.collectionsStatus,
          continuationStatusName: row.continuationStatusName,
          shelfCount: row.shelfCount,
          holdingCount: row.holdingCount,
          orderCount: row.orderCount,
          reserveCount: row.reserveCount,
          revision: row.revision
        }))
      )
    )
    this.onToggleReal(bibliographyId, BibliographyDetailRealTabType.Content)
  }

  onClickVolume(bibliographyId: number): void {
    modalBibliographyDetailStore.setSecondAfterTransitionSource(
      SecondAfterTransitionToBibliographyDetail.Set
    )
    modalBibliographyDetailSetStore.setVolumes(
      cloneDeep(
        this.bibliographySetDetail.volume.rows.map(row => ({
          prefix: row.prefix,
          bibliographyId: row.bibliographyId,
          collectionNo: row.collectionNo,
          marcNo: row.marcNo,
          bibliographyContentId: row.bibliographyContentId,
          volume: row.volume,
          volumeNumber: row.volumeNumber,
          volumeTotal: row.volumeTotal,
          volumeDateLabel: row.volumeDateLabel,
          volumeSpecial: row.volumeSpecial,
          displayContent: row.displayContent,
          continueAndLookCode: row.continueAndLookCode,
          collectionsStatus: row.collectionsStatus,
          continuationStatusName: row.continuationStatusName,
          shelfCount: row.shelfCount,
          holdingCount: row.holdingCount,
          orderCount: row.orderCount,
          reserveCount: row.reserveCount,
          revision: row.revision
        }))
      )
    )
    this.onToggleReal(
      bibliographyId,
      BibliographyDetailRealTabType.Bibliography
    )
  }

  onToggleReal(
    bibliographyId: number,
    tabType: BibliographyDetailRealTabType = BibliographyDetailRealTabType.Collection
  ): void {
    modalBibliographyDetailSetStore.toggleReal({ bibliographyId, tabType })
  }

  reset() {
    this.activeTab = BibliographyDetailSetTabType.Volume
    this.isFetchingBibliographySetDetail = false
    this.bibliographySetDetail = defaultBibliographySetDetailItem()
  }

  tabClass(value: BibliographyDetailSetTabType): string {
    return this.activeTab === value ? 'active' : ''
  }

  prev(): void {
    this.pagination(this.currentSearchResultIndex - 1)
  }

  next(): void {
    this.pagination(this.currentSearchResultIndex + 1)
  }

  pagination(index: number): void {
    if (index === -1) return

    modalBibliographyDetailStore.setSecondAfterTransitionSource(
      SecondAfterTransitionToBibliographyDetail.Pagination
    )

    const bibliographyFullId: BibliographyFullId = {
      prefix: this.searchResults[index].prefix,
      id: this.searchResults[index].bibliographyId
    }

    if (bibliographyFullId.prefix === Prefix.Real) {
      this.onToggleReal(bibliographyFullId.id)
      return
    }

    this.fetchBibliographySetDetail(bibliographyFullId.id)
  }

  setErrorMessage(alerts: Alert[], obj: any): void {
    alerts.forEach(alert => {
      if (alert.attribute === '') return false
      const key: keyof typeof obj = alert.attribute.replace(/_./g, str =>
        str.charAt(1).toUpperCase()
      ) as typeof obj
      const subKey: string = alert.subAttribute.replace(/_./g, str =>
        str.charAt(1).toUpperCase()
      )
      const splitKeys: string[] = (key as string).split('.')

      if (
        obj[key] !== undefined &&
        subKey !== '' &&
        Array.isArray(obj[key]) &&
        Object.prototype.toString
          .call(obj[key][alert.index][subKey])
          .slice(8, -1) === 'Object' &&
        (obj[key][alert.index][subKey] as any).hasOwnProperty('errorMessage')
      ) {
        ;(obj[key][alert.index][subKey] as any).errorMessage = alert.message
        return
      }

      if (
        obj[key] !== undefined &&
        Object.prototype.toString.call(obj[key]).slice(8, -1) === 'Object' &&
        (obj[key] as any).hasOwnProperty('errorMessage')
      ) {
        ;(obj[key] as any).errorMessage = alert.message
        return
      }

      if (splitKeys.length > 1 && subKey === '') {
        if (
          obj[splitKeys[0]][splitKeys[1]] !== undefined &&
          Object.prototype.toString
            .call(obj[splitKeys[0]][splitKeys[1]])
            .slice(8, -1) === 'Object' &&
          (obj[splitKeys[0]][splitKeys[1]] as any).hasOwnProperty(
            'errorMessage'
          )
        ) {
          ;(obj[splitKeys[0]][splitKeys[1]] as any).errorMessage = alert.message
        }
      }
    })
  }

  onClickPrint(): void {
    const element = document.getElementById('modal-bibliography-detail-set')
    if (element) {
      this.$webSocket.sendDialogScreenshotMessage(element)
    } else {
      this.$webSocket.sendScreenshotMessage()
    }
  }

  async fetchBibliographySetDetail(id: number) {
    try {
      this.isFetchingBibliographySetDetail = true

      const response: BibliographySetDetail = await bibliographySetApi.getBibliography(
        id
      )

      this.bibliographySetDetail = {
        bibliography: response.bibliography,
        volume: Object.assign(defaultBibliographyDetailVolumeTableItem(), {
          rows: response.volumes.map(
            (volume: BibliographySetDetailVolume, index: number) => {
              let isSelected: boolean

              if (
                this.bibliographySetDetail.bibliography.bibliographyId !== id
              ) {
                isSelected = index === 0
              } else {
                isSelected =
                  this.bibliographySetDetail.volume.selectedRow()
                    .bibliographyId === volume.bibliographyId
              }

              return {
                isSelected,
                ...volume
              }
            }
          ),
          sortColumn:
            this.bibliographySetDetail.bibliography.bibliographyId === id
              ? this.bibliographySetDetail.volume.sortColumn
              : defaultSortColumn()
        }),
        details: response.details,
        authorities: response.authorities,
        autoOrderInfo: Object.assign(defaultAutoOrderTableItem(), {
          rows: systemCodeStore.getLibraryBranch.map(systemCode => {
            let autoOrderInfo: BibliographySetDetailAutoOrder = defaultBibliographySetDetailAutoOrder()
            autoOrderInfo.orderBranchCode = systemCode

            for (const autoOrder of response.autoOrders) {
              if (autoOrder.orderBranchCode.code === systemCode.code) {
                autoOrderInfo = autoOrder
                break
              }
            }

            return {
              isSelected: false,
              orderAutoId: autoOrderInfo.id || null,
              orderBranchCode: autoOrderInfo.orderBranchCode,
              orderNumber: {
                input: String(autoOrderInfo.orderNumber),
                errorMessage: ''
              },
              traderCode: {
                input: autoOrderInfo.traderCode.code,
                display: autoOrderInfo.traderCode.shortName,
                errorMessage: ''
              },
              acceptType: {
                input: autoOrderInfo.acceptType.code,
                display: autoOrderInfo.acceptType.shortName,
                errorMessage: ''
              },
              buyDepartmentCode: {
                input: autoOrderInfo.buyDepartmentCode.code,
                display: autoOrderInfo.buyDepartmentCode.shortName,
                errorMessage: ''
              },
              donatedNumber: {
                input: String(autoOrderInfo.donatedNumber),
                errorMessage: ''
              },
              donorCode: {
                input: autoOrderInfo.donorCode.code,
                display: autoOrderInfo.donorCode.shortName,
                errorMessage: ''
              },
              budgetYear: {
                input: String(autoOrderInfo.budgetYear || ''),
                errorMessage: ''
              },
              budgetBranchCode: {
                input: autoOrderInfo.budgetBranchCode.code,
                display: autoOrderInfo.budgetBranchCode.shortName,
                errorMessage: ''
              },
              budgetDepartmentCode: {
                input: autoOrderInfo.budgetDepartmentCode.code,
                display: autoOrderInfo.budgetDepartmentCode.shortName,
                errorMessage: ''
              },
              budgetItem: {
                input: autoOrderInfo.budgetItem.code,
                display: autoOrderInfo.budgetItem.shortName,
                errorMessage: ''
              },
              equipType: {
                input: autoOrderInfo.equipType.code,
                display: autoOrderInfo.equipType.shortName,
                errorMessage: ''
              },
              collectionType: {
                input: autoOrderInfo.collectionType.code,
                display: autoOrderInfo.collectionType.shortName,
                errorMessage: ''
              },
              shelfType: {
                input: autoOrderInfo.shelfType.code,
                display: autoOrderInfo.shelfType.shortName,
                errorMessage: ''
              },
              handlingType: {
                input: autoOrderInfo.handlingType.code,
                display: autoOrderInfo.handlingType.shortName,
                errorMessage: ''
              },
              storeType: {
                input: autoOrderInfo.storeType.code,
                display: autoOrderInfo.storeType.shortName,
                errorMessage: ''
              },
              storingLimitCode: {
                input: autoOrderInfo.storingLimitCode.code,
                display: autoOrderInfo.storingLimitCode.shortName,
                errorMessage: ''
              },
              mark: {
                input: autoOrderInfo.mark,
                errorMessage: ''
              },
              ndc: {
                input: autoOrderInfo.ndc,
                errorMessage: ''
              },
              book: {
                input: autoOrderInfo.book,
                errorMessage: ''
              },
              sub: {
                input: autoOrderInfo.sub,
                errorMessage: ''
              },
              revision: autoOrderInfo.revision || null
            }
          })
        }),
        marcs: response.marcs,
        managementInfo: response.managementInfo
      }

      this.managementInfoInputItem = {
        bibliographySetId: this.bibliographySetDetail.bibliography.marcNo,
        maxBibliographyRealId: this.bibliographySetDetail.volume.rows.reduce(
          (accum: string, current: BibliographyDetailVolumeTableItemRow) =>
            current.marcNo > accum ? current.marcNo : accum,
          ''
        ),
        contractYear: {
          input: this.bibliographySetDetail.managementInfo.contractYear,
          errorMessage: ''
        },
        continuation: {
          input: this.bibliographySetDetail.managementInfo.continuation
        },
        openBookbinding: {
          input: this.bibliographySetDetail.managementInfo.openBookbinding
        },
        bookClaim: {
          input: this.bibliographySetDetail.managementInfo.bookClaim
        },
        needBookbinding: {
          input: this.bibliographySetDetail.managementInfo.needBookbinding
        },
        notArrived: {
          input: this.bibliographySetDetail.managementInfo.notArrived
        },
        traderCode: {
          input: this.bibliographySetDetail.managementInfo.traderCode.code,
          errorMessage: ''
        },
        donorCode: {
          input: this.bibliographySetDetail.managementInfo.donorCode.code,
          errorMessage: ''
        },
        shelfPlace: {
          input: this.bibliographySetDetail.managementInfo.shelfPlace,
          errorMessage: ''
        },
        memo7: {
          input: this.bibliographySetDetail.managementInfo.memo7,
          errorMessage: ''
        },
        holdingYear: {
          input: this.bibliographySetDetail.managementInfo.holdingYear,
          errorMessage: ''
        },
        holdingVolume: {
          input: this.bibliographySetDetail.managementInfo.holdingVolume,
          errorMessage: ''
        },
        missingNumberText: {
          input: this.bibliographySetDetail.managementInfo.missingNumberText,
          errorMessage: ''
        },
        memo3: {
          input: this.bibliographySetDetail.managementInfo.memo3,
          errorMessage: ''
        },
        memo4: {
          input: this.bibliographySetDetail.managementInfo.memo4,
          errorMessage: ''
        },
        memo2: {
          input: this.bibliographySetDetail.managementInfo.memo2,
          errorMessage: ''
        },
        retitleBefore: {
          input: this.bibliographySetDetail.managementInfo.retitleBefore,
          errorMessage: ''
        },
        retitleAfter: {
          input: this.bibliographySetDetail.managementInfo.retitleAfter,
          errorMessage: ''
        },
        memo1: {
          input: this.bibliographySetDetail.managementInfo.memo1,
          errorMessage: ''
        },
        memo6: {
          input: this.bibliographySetDetail.managementInfo.memo6,
          errorMessage: ''
        },
        memo5: {
          input: this.bibliographySetDetail.managementInfo.memo5,
          errorMessage: ''
        }
      }

      await this.fetchMarcLabel()
      await this.getBibliographySearchListDetail()
      this.isFetchingBibliographySetDetail = false
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
      modalBibliographyDetailSetStore.close()
    }
  }

  async fetchMarcLabel(): Promise<void> {
    try {
      this.firstMarcLabels = await marcLabelApi.getAll(
        BibliographyClass.Set,
        { ...defaultSystemCode(), code: SearchType.Magazine },
        false
      )
    } catch (error) {
      if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    }
  }

  async getBibliographySearchListDetail(displayBranchCode?: SystemCode) {
    this.$eventBus.emit(NAV_LOADING_START)

    try {
      this.isFetchingBibliographySetDetail = true

      // 繰り返し中に「bibliographySetDetail」が書き換わる可能性がある為、参照を変数に格納して処理する
      const tempReference: BibliographySetDetailItem = this
        .bibliographySetDetail

      const loopCount =
        Math.ceil(this.bibliographySetDetail.volume.rows.length) / 100
      let start: number = 0
      let end: number = 100

      for (let i = 0; i <= loopCount; i++) {
        if (
          this.bibliographySetDetail.volume.rows.length === 0 ||
          this.bibliographySetDetail !== tempReference ||
          start > tempReference.volume.rows.length - 1
        ) {
          return
        }

        if (end > tempReference.volume.rows.length) {
          end = tempReference.volume.rows.length
        }

        const bibliographies = tempReference.volume.rows
          .slice(start, end)
          .map(volume => {
            return {
              prefix: volume.prefix,
              id: volume.bibliographyId
            }
          })

        const responses: BibliographySearchListDetail[] = await bibliographyApi.getBibliographySearchListDetail(
          {
            bibliographies,
            displayBranchCode: displayBranchCode ?? defaultSystemCode()
          }
        )

        tempReference.volume.rows.forEach(volume => {
          const targetResponse:
            | BibliographySearchListDetail
            | undefined = responses.find(
            response =>
              response.prefix === volume.prefix &&
              response.bibliographyId === volume.bibliographyId
          )

          if (targetResponse !== undefined) {
            volume.collectionNo = targetResponse.collectionNo
            volume.collectionsStatus.shortName = targetResponse.collectionStatus
            volume.continuationStatusName =
              targetResponse.continuationStatusName
            volume.shelfCount = targetResponse.shelfCount
            volume.holdingCount = targetResponse.holdingCount
            volume.orderCount = targetResponse.orderCount
            volume.reserveCount = targetResponse.reserveCount
          }
        })

        start += 100
        end += 100
      }

      this.isFetchingBibliographySetDetail = false
    } catch (error) {
      if (error instanceof AlertMessage) {
        if (displayBranchCode) {
          this.setErrorMessage(error.alerts, this.displayBranchCode)
        }
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(NAV_LOADING_END)
    }
  }

  async updateBibliographySetManagementInfo(): Promise<void> {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      await bibliographySetApi.updateBibliographySetManagementInfo({
        id: this.bibliographySetDetail.managementInfo.id,
        bibliographySetId: this.bibliographySetDetail.bibliography
          .bibliographyId,
        continuation: this.managementInfoInputItem.continuation.input,
        notArrived: this.managementInfoInputItem.notArrived.input,
        openBookbinding: this.managementInfoInputItem.openBookbinding.input,
        bookClaim: this.managementInfoInputItem.bookClaim.input,
        shelfPlace: this.managementInfoInputItem.shelfPlace.input,
        traderCode: this.managementInfoInputItem.traderCode.input,
        donorCode: this.managementInfoInputItem.donorCode.input,
        missingNumberText: this.managementInfoInputItem.missingNumberText.input,
        retitleBefore: this.managementInfoInputItem.retitleBefore.input,
        retitleAfter: this.managementInfoInputItem.retitleAfter.input,
        contractYear: this.managementInfoInputItem.contractYear.input,
        holdingYear: this.managementInfoInputItem.holdingYear.input,
        holdingVolume: this.managementInfoInputItem.holdingVolume.input,
        needBookbinding: this.managementInfoInputItem.needBookbinding.input,
        memo1: this.managementInfoInputItem.memo1.input,
        memo2: this.managementInfoInputItem.memo2.input,
        memo3: this.managementInfoInputItem.memo3.input,
        memo4: this.managementInfoInputItem.memo4.input,
        memo5: this.managementInfoInputItem.memo5.input,
        memo6: this.managementInfoInputItem.memo6.input,
        memo7: this.managementInfoInputItem.memo7.input,
        revision: this.bibliographySetDetail.managementInfo.revision
      })

      this.fetchBibliographySetDetail(this.bibliographySetId)
    } catch (error) {
      if (error instanceof AlertMessage) {
        this.setErrorMessage(error.alerts, this.managementInfoInputItem)
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  createMagazineBookNumberList(): void {
    this.$eventBus.emit(PAGE_LOADING_START)

    const createMagazineBookNumberList = async () => {
      try {
        const jobId = await jobApi.createMagazineBookNumberList({
          bibliographySetId: this.bibliographySetId,
          searchList: this.bibliographySetDetail.volume.rows.map(volume => {
            return {
              bibliographyRealId: volume.bibliographyId,
              collectionNo: volume.collectionNo,
              collectionStatusName:
                volume.collectionsStatus.shortName !== ''
                  ? volume.collectionsStatus.shortName
                  : volume.continuationStatusName,
              shelfCount: volume.shelfCount,
              holdingCount: volume.holdingCount,
              orderCount: volume.orderCount,
              reserveCount: volume.reserveCount
            }
          })
        })

        await modalJobListStore.newJobId(jobId)
      } catch (error) {
        if (error instanceof AlertMessage) {
          alertStore.setItems(error.alerts)
          this.$modalAlert.open()
        } else if (error instanceof ErrorMessage) {
          modalErrorStore.init(error)
          this.$modalError.open()
        } else {
          console.error(error)
        }
      } finally {
        this.$eventBus.emit(PAGE_LOADING_END)
      }
    }

    if (this.isFetchingBibliographySetDetail) {
      const unwatch = this.$watch('isFetchingBibliographySetDetail', () => {
        createMagazineBookNumberList().finally(unwatch)
      })
      return
    }

    createMagazineBookNumberList()
  }
}
